export default __webpack_public_path__ + "static/media/image7.d2ccb516.jpg";